export default {
  LIVE: 'LIVE',
  BUILD: 'BUILD'
}
